import React from 'react'
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';

function PaymentErorr() {
  return (
    <div>
        <TopBaner></TopBaner>
        <div className='card'>
            <h1>שגיאה</h1>
            <p> בעקבות שגיאה כרטיסך לא חויב </p>
            <p> נא הזמן נסיעה חדשה </p>
        </div>
        <SideBar></SideBar>
        <Footer></Footer>
    </div>
  )
}

export default PaymentErorr